// extracted by mini-css-extract-plugin
export default {"wrapper":"Pineapple_wrapper__Fv5ik","heading":"Pineapple_heading__RhkZE","grid":"Pineapple_grid__oyecc"};